const shouldPluralize = (amount: number) => {
    const ordinalRules = new Intl.PluralRules('en-US', { type: 'ordinal' })

    return ordinalRules.select(amount) !== 'one'
}

/**
 * Convert a given time duration into a human readable format
 * @param {number} duration - duration in seconds
 * @returns {string} presentation (minutes / hours)
 */
export const durationHumanize = (duration: number) => {
    const HOUR = 3600 // in seconds
    if (duration < HOUR) {
        const minutes = Math.round(duration / 60)

        return `${minutes} minute${shouldPluralize(minutes) ? 's' : ''}`
    }

    const hoursWithPrecision = (duration / HOUR).toFixed(1)
    const hours = Number(hoursWithPrecision)

    return Number.isInteger(hours) ? `${hours} hour${shouldPluralize(hours) ? 's' : ''}` : `${hoursWithPrecision} hours`
}

export const shouldUse24HTimeFormat = (() => {
    // by passing `undefined` as locale, we make browser use default one,
    // usually derived from browser language
    const parts = new Intl.DateTimeFormat(undefined, {
        hour: 'numeric',
    }).formatToParts(new Date())

    // "dayPeriod" part is for AM/PM, so when it's present - it's 12h format, otherwise 24h
    return !parts.some((p) => p.type === 'dayPeriod')
})()
